<template>
    <div class="row justify-content-center">
        <div class="col-lg-4 col-md-8 col-10">
            <img src="/images/pg-logo-wide-white.png" class="mb-md-0" alt="" style="width:100%;" v-show="showLogo">
        </div>
        <div class="col-12"></div>
        <div class="col-lg-8 col-md-8 col-10 mb-6 mt-5 mb-5 mb-md-3">
            <div class="px-4">
                <h1 class="text-light">
                    Investeer in jezelf
                </h1>
            </div>
        </div>
        <div class="col-12"></div>
        <div class="col-lg-9 col-md-9 col-sm-9 col-10 mt-4">
            <action-buttons aanmeld-text="Probeer de eerste maand voor €1"></action-buttons>
        </div>
    </div>
</template>

<script>

import ActionButtons from "./ActionButtons";
export default {
    components: {ActionButtons},

    props: {
        showLogo: {default: true},
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
